<template>
  <el-menu-item :index="item.children[0].path" v-if="isSingle(item)" class="nav-item" style="padding-left: 21px">
    <i :class="['fa', item.children[0].meta.icon ? item.children[0].meta.icon : '']"></i><span>{{ item.children[0].meta.title }}</span>
  </el-menu-item>
  <el-submenu class="nav-item" :index="item.path" v-else-if="item.children && item.children.length > 0 && !item.hidden">
    <template slot="title" v-if="item.meta && item.meta.title">
      <i :class="['fa', (item.meta && item.meta.icon) ? item.meta.icon : '']"></i><span>{{ item.meta.title }}</span>
    </template>
    <div v-for="child in item.children" :key="child">
      <menu-item v-if="child.children && child.children.length > 0" :param="child"></menu-item>
      <el-menu-item :index="item.path + '/' + child.path" v-else-if="!child.hidden">
        <i :class="['fa', child.meta.icon ? child.meta.icon : '']"></i><span>{{ child.meta.title }}</span>
      </el-menu-item>
    </div>
  </el-submenu>
  <el-menu-item :index="item.path" v-else-if="!item.hidden" class="el-menu-each">
    <i :class="['fa', item.meta.icon ? item.meta.icon : '']"></i><span>{{ item.meta.title }}</span>
  </el-menu-item>
</template>

<script>
import menuItem from './MenuItem.vue'

export default {
  name: 'menuItem',
  props: ['param'],
  data: function() {
    return { item: this.param }
  },
  computed:{
  },
  components: {
    menuItem
  },
  methods:{
    isSingle(menu) {
      if(menu.children){
        let subMenu = menu.children.filter(m=>{ return !m.hidden })
        if(subMenu.length == 1){
          return true
        }
      }
      return false
    }
  }
}
</script>
